import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';

export function LogsEmpty() {
  const {t} = useTranslation();

  return (
    <Box className="action">
      <Box className="action-description">
        <Box className="status">
          <Typography>{t(translations.section_list.without_data)}</Typography>
        </Box>
      </Box>
    </Box>
  );
}
